// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FileMarkdownOutlinedSvg from "@ant-design/icons-svg/es/asn/FileMarkdownOutlined";
import AntdIcon from '../components/AntdIcon';

var FileMarkdownOutlined = function FileMarkdownOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: FileMarkdownOutlinedSvg
  }));
};

FileMarkdownOutlined.displayName = 'FileMarkdownOutlined';
export default React.forwardRef(FileMarkdownOutlined);